export default __webpack_public_path__ + "f79c918eeb3b0adb956166b1d49427c2.png";